import { render, staticRenderFns } from "./EstimateStatusList.vue?vue&type=template&id=2876108e&scoped=true&"
import script from "./EstimateStatusList.vue?vue&type=script&lang=js&"
export * from "./EstimateStatusList.vue?vue&type=script&lang=js&"
import style0 from "./EstimateStatusList.vue?vue&type=style&index=0&id=2876108e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876108e",
  null
  
)

component.options.__file = "EstimateStatusList.vue"
export default component.exports